import script from "./success.vue?vue&type=script&lang=ts&setup=true"
export * from "./success.vue?vue&type=script&lang=ts&setup=true"

import "./success.vue?vue&type=style&index=0&id=3cdaabea&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cdaabea"]])

export default __exports__